import { useRef, type ReactNode } from 'react';

export function Card({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <section className={`card ${className}`}>{children}</section>;
}

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return <label className="field"><span>{label}</span>{children}</label>;
}

export function Skeleton() {
  return <div className="skeleton"><span /><span /><span /></div>;
}

export function Modal({ open, title, children, onClose }: { open: boolean; title: string; children: ReactNode; onClose: () => void }) {
  if (!open) return null;
  return <div className="modal" onClick={onClose}><div className="modal-box" onClick={(e) => e.stopPropagation()}><div className="modal-head"><h2>{title}</h2><button className="btn ghost" onClick={onClose}>Close</button></div>{children}</div></div>;
}

export function ConfirmModal({ open, title, message, details, confirmLabel = 'Confirm', tone = 'primary', loading = false, onCancel, onConfirm }: {
  open: boolean;
  title: string;
  message: string;
  details?: Array<{ label: string; value: ReactNode }>;
  confirmLabel?: string;
  tone?: 'primary' | 'danger';
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<unknown> | unknown;
}) {
  const localSubmitting = useRef(false);
  const confirm = async () => {
    if (loading || localSubmitting.current) return;
    localSubmitting.current = true;
    try {
      await onConfirm();
    } finally {
      localSubmitting.current = false;
    }
  };
  if (!open) return null;
  return <div className="modal" onClick={loading ? undefined : onCancel}>
    <div className="modal-box confirm-box" onClick={(e) => e.stopPropagation()}>
      <div className="modal-head"><h2>{title}</h2><button className="btn ghost" disabled={loading} onClick={onCancel}>Cancel</button></div>
      <p className="muted">{message}</p>
      {details?.length ? <div className="confirm-details">{details.map((item) => <p key={item.label}><b>{item.label}</b><span>{item.value}</span></p>)}</div> : null}
      <div className="confirm-actions"><button className="btn" disabled={loading} onClick={onCancel}>Cancel</button><button className={`btn ${tone === 'danger' ? 'danger' : 'primary'}`} disabled={loading} onClick={confirm}>{loading ? 'Working...' : confirmLabel}</button></div>
    </div>
  </div>;
}
